import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "@/layout";

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true,
  },
  {
    path: "/404",
    component: () => import("@/views/404"),
    hidden: true,
  },
  // { path: '/', redirect:'/party/buildingList' },
  {
    path: "/",
    component: Layout,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        name: "首页",
        component: () => import("@/views/dashboard/index"),
        meta: { title: "首页" },
      },
    ],
  },
  // {
  //   path: '/dashboard',
  //   component: Layout,
  //   children: [{
  //     path: '',
  //     name: '首页',
  //     component: () => import('@/views/dashboard/index'),
  //     meta: { title: '首页' }
  //   }]
  // },
  {
    path: "/menu",
    component: Layout,
    // redirect: '/menuLists',
    children: [
      {
        path: "lists",
        name: "后台菜单列表",
        component: () => import("@/views/menu/lists"),
        meta: { title: "后台菜单列表" },
      },
      {
        path: "miniLists",
        name: "小程序菜单列表",
        component: () => import("@/views/menu/miniLists"),
        meta: { title: "小程序菜单列表" },
      },
      {
        path: "appLists",
        name: "APP菜单列表",
        component: () => import("@/views/menu/appLists"),
        meta: { title: "APP菜单列表" },
      },
    ],
  },
  {
    path: "/admin_user",
    component: Layout,
    // redirect: '/menuLists',
    children: [
      {
        path: "lists",
        name: "后台管理员列表",
        component: () => import("@/views/admin_user/lists"),
        meta: { title: "后台管理员列表" },
      },
      {
        path: "agoList",
        name: "游客用户管理",
        component: () => import("@/views/admin_user/agoList"),
        meta: { title: "游客用户管理" },
      },
      {
        path: "caller",
        name: "访客预约列表",
        component: () => import("@/views/admin_user/caller"),
        meta: { title: "访客预约列表" },
      },
      {
        path: "houseUserList",
        name: "住宅用户列表",
        component: () => import("@/views/admin_user/houseUserList"),
        meta: { title: "住宅用户列表" },
      },
    ],
  },
  {
    path: "/role",
    component: Layout,
    name: "角色管理",
    // redirect: '/menuLists',
    children: [
      {
        path: "index",
        name: "后台角色管理",
        component: () => import("@/views/role/index"),
        meta: { title: "后台角色管理" },
      },
      {
        path: "miniIndex",
        name: "小程序角色管理",
        component: () => import("@/views/role/miniIndex"),
        meta: { title: "小程序角色管理" },
      },
    ],
  },
  {
    path: "/park",
    component: Layout,
    // redirect: '/menuLists',
    children: [
      {
        path: "index",
        name: "园区列表",
        component: () => import("@/views/park/index"),
        meta: { title: "园区列表" },
      },
      {
        path: "userList",
        name: "园区员工列表",
        component: () => import("@/views/park/userList"),
        meta: { title: "园区员工列表" },
      },
    ],
  },
  {
    path: "/enterprise",
    component: Layout,
    // redirect: '/menuLists',
    children: [
      {
        path: "index",
        name: "企业列表",
        component: () => import("@/views/enterprise/index"),
        meta: { title: "企业列表" },
      },
      {
        path: "userList",
        name: "企业员工列表",
        component: () => import("@/views/enterprise/userList"),
        meta: { title: "企业员工列表" },
      },
      {
        path: "applyList",
        name: "企业员工申请列表",
        component: () => import("@/views/enterprise/applyList"),
        meta: { title: "企业员工申请列表" },
      },
    ],
  },
  {
    path: "/repairs",
    component: Layout,
    // redirect: '/menuLists',
    children: [
      {
        path: "index",
        name: "工单工作台",
        component: () => import("@/views/repairs/index"),
        meta: { title: "工单工作台" },
      },
      {
        path: "cause",
        name: "工单原因类型",
        component: () => import("@/views/repairs/cause"),
        meta: { title: "工单原因类型" },
      },
      {
        path: "reason",
        name: "转单原因",
        component: () => import("@/views/repairs/reason"),
        meta: { title: "转单原因" },
      },
      {
        path: "addword",
        name: "自查房报事",
        component: () => import("@/views/repairs/addword"),
        meta: { title: "自查房报事" },
      },
      {
        path: "addproprietor",
        name: "业主报事",
        component: () => import("@/views/repairs/addproprietor"),
        meta: { title: "业主报事" },
      },
      {
        path: "addDwelling",
        name: "住宅报事",
        component: () => import("@/views/repairs/addDwelling"),
        meta: { title: "住宅报事" },
      },
      {
        path: "proprietor",
        name: "业主报事报修列表",
        component: () => import("@/views/repairs/proprietor"),
        meta: { title: "业主报事报修列表" },
      },
    ],
  },
  {
    path: "/polling",
    component: Layout,
    // redirect: '/menuLists',
    children: [
      {
        path: "index",
        name: "巡检点列表",
        component: () => import("@/views/polling/index"),
        meta: { title: "巡检点列表" },
      },
      {
        path: "course",
        name: "巡检路线列表",
        component: () => import("@/views/polling/course"),
        meta: { title: "巡检路线列表" },
      },
      {
        path: "task",
        name: "巡检任务列表",
        component: () => import("@/views/polling/task"),
        meta: { title: "巡检任务列表" },
      },
      {
        path: "record",
        name: "巡检记录列表",
        component: () => import("@/views/polling/record"),
        meta: { title: "巡检记录列表" },
      },
    ],
  },
  {
    path: "/article",
    component: Layout,
    // redirect: '/menuLists',
    children: [
      {
        path: "index",
        name: "新闻资讯列表",
        component: () => import("@/views/article/index"),
        meta: { title: "新闻资讯列表" },
      },
      {
        path: "tips",
        name: "公告列表",
        component: () => import("@/views/article/tips"),
        meta: { title: "公告列表" },
      },
    ],
  },
  {
    path: "/carousel",
    component: Layout,
    // redirect: '/menuLists',
    children: [
      {
        path: "index",
        name: "轮播图管理",
        component: () => import("@/views/carousel/index"),
        meta: { title: "轮播图管理" },
      },
    ],
  },
  {
    path: "/basics",
    component: Layout,
    children: [
      {
        path: "parkingFee",
        name: "停车缴费记录",
        component: () => import("@/views/basics/parkingFee"),
        meta: { title: "停车缴费记录" },
      },
      {
        path: "parkCode",
        name: "园区码使用记录",
        component: () => import("@/views/basics/parkCode"),
        meta: { title: "园区码使用记录" },
      },
    ],
  },
  {
    path: "/activity",
    component: Layout,
    // redirect: '/menuLists',
    children: [
      {
        path: "index",
        name: "活动管理",
        component: () => import("@/views/activity/index"),
        meta: { title: "活动管理" },
      },
    ],
  },
  {
    path: "/visitor",
    component: Layout,
    // redirect: '/menuLists',
    children: [
      {
        path: "index",
        name: "访客预约",
        component: () => import("@/views/visitor/index"),
        meta: { title: "访客预约" },
      },
    ],
  },
  {
    path: "/housesTenancy",
    component: Layout,
    // redirect: '/menuLists',
    children: [
      {
        path: "index",
        name: "房屋租赁列表",
        component: () => import("@/views/housesTenancy/index"),
        meta: { title: "房屋租赁列表" },
      },
      {
        path: "homeBanner",
        name: "租赁轮播图",
        component: () => import("@/views/housesTenancy/homeBanner"),
        meta: { title: "租赁轮播图" },
      },
      // {
      //   path: 'typeList',
      //   name: '房屋类型',
      //   component: () => import('@/views/housesTenancy/typeList'),
      //   meta: { title: '房屋类型' }
      // },
      {
        path: "registerUserList",
        name: "意向用户列表",
        component: () => import("@/views/housesTenancy/registerUserList"),
        meta: { title: "意向用户列表" },
      },
    ],
  },
  {
    path: "/investment",
    component: Layout,
    // redirect: '/menuLists',
    children: [
      {
        path: "projectIntroduction",
        name: "项目介绍",
        component: () => import("@/views/investment/projectIntroduction"),
        meta: { title: "项目介绍" },
      },
      {
        path: "configuration",
        name: "项目配置",
        component: () => import("@/views/investment/configuration"),
        meta: { title: "项目配置" },
      },
      {
        path: "parkIntro",
        name: "项目列表",
        component: () => import("@/views/investment/parkIntro"),
        meta: { title: "项目列表" },
      },
      {
        path: "advantages",
        name: "投资优势",
        component: () => import("@/views/investment/advantages"),
        meta: { title: "投资优势" },
      },
      {
        path: "agencyPolicy",
        name: "招商政策",
        component: () => import("@/views/investment/agencyPolicy"),
        meta: { title: "招商政策" },
      },
      {
        path: "businessCard",
        name: "招商名片",
        component: () => import("@/views/investment/businessCard"),
        meta: { title: "招商名片" },
      },
      {
        path: "leaveWord",
        name: "招商留言",
        component: () => import("@/views/investment/leaveWord"),
        meta: { title: "招商留言" },
      },
    ],
  },
  {
    path: "/equipment",
    component: Layout,
    // redirect: '/menuLists',
    children: [
      {
        path: "facilityList",
        name: "设施管理",
        component: () => import("@/views/equipment/facilityList"),
        meta: { title: "设施管理" },
      },
      {
        path: "equipmentList",
        name: "设备管理",
        component: () => import("@/views/equipment/equipmentList"),
        meta: { title: "设备管理" },
      },
      {
        path: "equipmentType",
        name: "设备类型",
        component: () => import("@/views/equipment/equipmentType"),
        meta: { title: "设备类型" },
      },
      {
        path: "equipmentPatrol",
        name: "设备巡检",
        component: () => import("@/views/equipment/equipmentPatrol"),
        meta: { title: "设备巡检" },
      },
      {
        path: "record",
        name: "设备巡检记录",
        component: () => import("@/views/equipment/record"),
        meta: { title: "设备巡检记录" },
      },
    ],
  },
  {
    path: "/space",
    component: Layout,
    // redirect: '/menuLists',
    children: [
      {
        path: "index",
        name: "楼宇列表",
        component: () => import("@/views/space/index"),
        meta: { title: "楼宇列表" },
        children: [
          {
            path: "details",
            name: "详情",
            component: () => import("@/views/space/details"),
            meta: { title: "详情" },
            activeMenu: "/space/index",
          },
        ],
      },
      {
        path: "typeList",
        name: "房屋类型",
        component: () => import("@/views/space/typeList"),
        meta: { title: "房屋类型" },
      },
    ],
  },
  {
    path: "/conf",
    component: Layout,
    // redirect: '/menuLists',
    children: [
      {
        path: "note",
        name: "短信配置",
        component: () => import("@/views/conf/note"),
        meta: { title: "短信配置" },
      },
      {
        path: "privacy",
        name: "隐私政策",
        component: () => import("@/views/conf/privacy"),
        meta: { title: "隐私政策" },
      },
      {
        path: "push",
        name: "推送配置",
        component: () => import("@/views/conf/push"),
        meta: { title: "推送配置" },
      },
      {
        path: "appUp",
        name: "APP更新配置",
        component: () => import("@/views/conf/appUp"),
        meta: { title: "APP更新配置" },
      },
      {
        path: "holiday",
        name: "国定假期",
        component: () => import("@/views/conf/holiday"),
        meta: { title: "国定假期" },
      },
      {
        path: "manufacturer",
        name: "硬件厂商列表",
        component: () => import("@/views/conf/manufacturer"),
        meta: { title: "硬件厂商列表" },
      },
      {
        path: "hardware",
        name: "硬件配置",
        component: () => import("@/views/conf/hardware"),
        meta: { title: "硬件配置" },
      },
      {
        path: "hmpList",
        name: "园区硬件配置列表",
        component: () => import("@/views/conf/hmpList"),
        meta: { title: "园区硬件配置列表" },
      },
      {
        path: "format",
        name: "初始化数据",
        component: () => import("@/views/conf/format"),
        meta: { title: "初始化数据" },
      },
      {
        path: "zombieCarConfig",
        name: "僵尸车配置",
        component: () => import("@/views/conf/zombieCarConfig"),
        meta: { title: "僵尸车配置" },
      },
      {
        path: "notification",
        name: "通知模版列表",
        component: () => import("@/views/conf/notification"),
        meta: { title: "通知模版列表" },
      },
      {
        path: "parkRelLists",
        name: "园区管理模版配置列表",
        component: () => import("@/views/conf/parkRelLists"),
        meta: { title: "园区管理模版配置列表" },
      },
      {
        path: "stationNotification",
        name: "工位到期提醒时间设置",
        component: () => import("@/views/conf/stationNotification"),
        meta: { title: "工位到期提醒时间设置" },
      },
    ],
  },
  {
    path: "/statistics",
    component: Layout,
    // redirect: '/menuLists',
    children: [
      {
        path: "statistics",
        name: "品质巡检任务统计",
        component: () => import("@/views/statistics/statistics"),
        meta: { title: "品质巡检任务统计" },
      },
      // {
      //   path: 'privacy',
      //   name: '隐私政策',
      //   component: () => import('@/views/conf/privacy'),
      //   meta: { title: '隐私政策' },
      // },
      // {
      //   path: 'push',
      //   name: '推送配置',
      //   component: () => import('@/views/conf/push'),
      //   meta: { title: '推送配置' },
      // }
    ],
  },
  {
    path: "/parkingManage",
    component: Layout,
    // redirect: '/menuLists',
    children: [
      {
        path: "costConfig",
        name: "车位费用配置",
        component: () => import("@/views/parkingManage/costConfig"),
        meta: { title: "车位费用配置" },
      },
      {
        path: "applyList",
        name: "包月车位申请列表",
        component: () => import("@/views/parkingManage/applyList"),
        meta: { title: "包月车位申请列表" },
      },
      {
        path: "plateList",
        name: "车牌列表",
        component: () => import("@/views/parkingManage/plateList"),
        meta: { title: "车牌列表" },
      },
      {
        path: "record",
        name: "车辆缴费记录",
        component: () => import("@/views/parkingManage/record"),
        meta: { title: "车辆缴费记录 " },
      },
      {
        path: "carRecord",
        name: "车辆出入记录",
        component: () => import("@/views/parkingManage/carRecord"),
        meta: { title: "车辆出入记录 " },
      },
      {
        path: "zombieList",
        name: "僵尸车列表",
        component: () => import("@/views/parkingManage/zombieList"),
        meta: { title: "僵尸车列表 " },
      },
      {
        path: "coupons",
        name: "停车优惠券列表",
        component: () => import("@/views/parkingManage/coupons"),
        meta: { title: "停车优惠券列表 " },
      },
      {
        path: "couponTemplate",
        name: "优惠券模板列表",
        component: () => import("@/views/parkingManage/couponTemplate"),
        meta: { title: "优惠券模板列表 " },
      },
      {
        path: "parkingInfo",
        name: "车场信息",
        component: () => import("@/views/parkingManage/parkingInfo"),
        meta: { title: "车场信息 " },
      },
      {
        path: "couponRecord",
        name: "优惠券使用记录",
        component: () => import("@/views/parkingManage/couponRecord"),
        meta: { title: "优惠券使用记录 " },
      },
    ],
  },
  {
    path: "/survey",
    component: Layout,
    // redirect: '/menuLists',
    children: [
      // {
      //   path: 'theme',
      //   name: '问卷主题列表',
      //   component: () => import('@/views/survey/theme'),
      //   meta: { title: '问卷主题列表' },
      // },
      // {
      //   path: 'ques',
      //   name: '问卷问题列表',
      //   component: () => import('@/views/survey/ques'),
      //   meta: { title: '问卷问题列表' },
      // },
      {
        path: "surveyComplete",
        name: "添加完整问卷",
        component: () => import("@/views/survey/surveyComplete"),
        meta: { title: "添加完整问卷" },
      },
    ],
  },
  {
    path: "/invoice",
    component: Layout,
    // redirect: '/menuLists',
    children: [
      {
        path: "index",
        name: "线下发票列表",
        component: () => import("@/views/invoice/index"),
        meta: { title: "线下发票列表" },
      },
    ],
  },
  {
    path: "/enterpriseFw",
    component: Layout,
    // redirect: '/menuLists',
    children: [
      {
        path: "typeList",
        name: "企业服务类型列表",
        component: () => import("@/views/enterpriseFw/typeList"),
        meta: { title: "企业服务类型列表" },
      },
      {
        path: "serviceList",
        name: "企业服务公司列表",
        component: () => import("@/views/enterpriseFw/serviceList"),
        meta: { title: "企业服务公司列表" },
      },
    ],
  },
  {
    path: "/place",
    component: Layout,
    // redirect: '/menuLists',
    children: [
      {
        path: "index",
        name: "场地列表",
        component: () => import("@/views/place/index"),
        meta: { title: "场地列表" },
      },
      {
        path: "applyList",
        name: "场地预约列表",
        component: () => import("@/views/place/applyList"),
        meta: { title: "场地预约列表" },
      },
    ],
  },
  {
    path: "/userSign",
    component: Layout,
    // redirect: '/menuLists',
    children: [
      {
        path: "index",
        name: "用户签到配置列表",
        component: () => import("@/views/userSign/index"),
        meta: { title: "用户签到配置列表" },
      },
      {
        path: "signList",
        name: "用户签到列表",
        component: () => import("@/views/userSign/signList"),
        meta: { title: "用户签到列表" },
      },
    ],
  },
  {
    path: "/party",
    component: Layout,
    // redirect: '/menuLists',
    children: [
      {
        path: "applyLIst",
        name: "党员申请列表",
        component: () => import("@/views/party/applyList"),
        meta: { title: "党员申请列表" },
      },
      {
        path: "list",
        name: "党员列表",
        component: () => import("@/views/party/list"),
        meta: { title: "党员列表" },
      },
      {
        path: "buildingList",
        name: "党建列表",
        component: () => import("@/views/party/buildingList"),
        meta: { title: "党建列表" },
      },
    ],
  },
  {
    path: "/logs",
    component: Layout,
    // redirect: '/menuLists',
    children: [
      {
        path: "index",
        name: "用户操作日志列表",
        component: () => import("@/views/logs/index"),
        meta: { title: "用户操作日志列表" },
      },
    ],
  },
  {
    path: "/device",
    component: Layout,
    // redirect: '/menuLists',
    children: [
      {
        path: "organLists",
        name: "硬件组织列表",
        component: () => import("@/views/device/organLists"),
        meta: { title: "硬件组织列表" },
      },
      {
        path: "organUserLists",
        name: "硬件人员列表",
        component: () => import("@/views/device/organUserLists"),
        meta: { title: "硬件人员列表" },
      },
    ],
  },
  {
    path: "/dataConfiguration",
    component: Layout,
    // redirect: '/menuLists',
    children: [
      {
        path: "yunzhou",
        name: "云州大屏数据",
        component: () => import("@/views/dataConfiguration/yunzhou/index"),
        meta: { title: "云州大屏数据" },
      },
      {
        path: "wuchang",
        name: "五常大屏数据",
        component: () => import("@/views/dataConfiguration/wuchang/index"),
        meta: { title: "五常大屏数据" },
      },
      // {
      //   path: 'index',
      //   name: '云州大屏',
      //   component: () => import('@/views/carPlay/index'),
      //   meta: { title: '云州大屏' },
      // }
    ],
  },
  {
    path: "/house",
    component: Layout,
    children: [
      {
        path: "index",
        name: "住宅列表",
        component: () => import("@/views/house/index"),
        meta: { title: "住宅列表" },
      },
      {
        path: "applyList",
        name: "住宅用户申请列表",
        component: () => import("@/views/house/applyList"),
        meta: { title: "住宅用户申请列表" },
      },
    ],
  },
  {
    path: "/adviceFeedback",
    component: Layout,
    children: [
      {
        path: "index",
        name: "反馈列表",
        component: () => import("@/views/adviceFeedback/index"),
        meta: { title: "反馈列表" },
      },
    ],
  },
  {
    path: "/property",
    component: Layout,
    children: [
      {
        path: "index",
        name: "物业服务列表",
        component: () => import("@/views/property/index"),
        meta: { title: "物业服务列表" },
      },
      {
        path: "commentLists",
        name: "物业服务评论列表",
        component: () => import("@/views/property/commentLists"),
        meta: { title: "物业服务评论列表" },
      },
      {
        path: "orderLists",
        name: "物业服务订单列表",
        component: () => import("@/views/property/orderLists"),
        meta: { title: "物业服务订单列表" },
      },
      {
        path: "feeLists",
        name: "物业&租赁费用列表",
        component: () => import("@/views/property/feeLists"),
        meta: { title: "物业&租赁费用列表" },
      },
    ],
  },
  {
    path: "/renovation",
    component: Layout,
    children: [
      {
        path: "setList",
        name: "装修资料",
        component: () => import("@/views/renovation/setList"),
        meta: { title: "装修资料" },
      },
      {
        path: "applyList",
        name: "装修列表",
        component: () => import("@/views/renovation/applyList"),
        meta: { title: "装修列表" },
      },
      {
        path: "taskList",
        name: "装修任务列表",
        component: () => import("@/views/renovation/taskList"),
        meta: { title: "装修任务列表" },
      },
      {
        path: "punchList",
        name: "装修巡检记录列表",
        component: () => import("@/views/renovation/punchList"),
        meta: { title: "装修巡检记录列表" },
      },
      // {
      //   path: "index",
      //   name: "装修巡检记录列表",
      //   component: () => import("@/views/renovation/index"),
      //   meta: { title: "装修巡检记录列表" },
      // },

      {
        path: "statistics",
        name: "装修统计",
        component: () => import("@/views/renovation/statistics"),
        meta: { title: "装修统计" },
      },
    ],
  },
  {
    path: "/energy",
    component: Layout,
    children: [
      {
        path: "config",
        name: "能耗配置",
        component: () => import("@/views/energy/config"),
        meta: { title: "能耗配置" },
      },

      {
        path: "index",
        name: "能耗列表",
        component: () => import("@/views/energy/index"),
        meta: { title: "能耗列表" },
        children: [
          {
            path: "details",
            name: "能耗详情",
            component: () => import("@/views/energy/details"),
            meta: { title: "能耗详情" },
            activeMenu: "/energy/index",
          }
        ],
      },
      {
        path: "taskLists",
        name: "能耗模板列表",
        component: () => import("@/views/energy/taskLists"),
        meta: { title: "能耗模板列表" },
      },
      {
        path: "recordLists",
        name: "能耗记录列表",
        component: () => import("@/views/energy/recordLists"),
        meta: { title: "能耗记录列表" },
      },
      {
        path: "orderLists",
        name: "能耗账单列表",
        component: () => import("@/views/energy/orderLists"),
        meta: { title: "能耗账单列表" },
      },
      {
        path: "taskDay",
        name: "能耗任务列表",
        component: () => import("@/views/energy/taskDay"),
        meta: { title: "能耗任务列表" },
      },
    ],
  },
  {
    path: "/tag",
    component: Layout,
    children: [
      {
        path: "lists",
        name: "标签列表",
        component: () => import("@/views/tag/lists"),
        meta: { title: "标签列表" },
      },
    ],
  },
  {
    path: "/smartFarm",
    component: Layout,
    // redirect: '/menuLists',
    children: [
      {
        path: "venueList",
        name: "会场列表",
        component: () => import("@/views/smartFarm/venueList"),
        meta: { title: "会场列表" },
      },
      {
        path: "venueApplyList",
        name: "会场预约列表",
        component: () => import("@/views/smartFarm/venueApplyList"),
        meta: { title: "会场预约列表" },
      },
      {
        path: "farmList",
        name: "农场列表",
        component: () => import("@/views/smartFarm/farmList"),
        meta: { title: "农场列表" },
      },
      {
        path: "farmApplyList",
        name: "农场申请列表",
        component: () => import("@/views/smartFarm/farmApplyList"),
        meta: { title: "农场申请列表" },
      },
      {
        path: "fishing",
        name: "钓台配置",
        component: () => import("@/views/smartFarm/fishing"),
        meta: { title: "钓台配置" },
      },
      {
        path: "orderList",
        name: "钓台订单列表",
        component: () => import("@/views/smartFarm/orderList"),
        meta: { title: "钓台订单列表" },
      },
    ],
  }, {
    path: "/shop",
    component: Layout,
    // redirect: '/menuLists',
    children: [
      {
        path: "goodsList",
        name: "商品列表",
        component: () => import("@/views/shop/goodsList"),
        meta: { title: "商品列表" },
      },
      {
        path: "goodsTypeList",
        name: "商品类型列表",
        component: () => import("@/views/shop/goodsTypeList"),
        meta: { title: "商品类型列表" },
      },
      {
        path: "orderList",
        name: "订单列表",
        component: () => import("@/views/shop/orderList"),
        meta: { title: "订单列表" },
      },
      {
        path: "orderRefundList",
        name: "订单申请退款列表",
        component: () => import("@/views/shop/orderRefundList"),
        meta: { title: "订单申请退款列表" },
      },
      {
        path: "commentLists",
        name: "订单评论列表",
        component: () => import("@/views/shop/commentLists"),
        meta: { title: "订单评论列表" },
      },
    ],
  },
  {
    path: "/sharedOffice",
    component: Layout,
    children: [
      {
        path: "stationReservation/index",
        name: "工位列表",
        component: () => import("@/views/sharedOffice/stationReservation/index"),
        meta: { title: "工位列表" },
      },
      {
        path: "stationReservation/record",
        name: "工位预约记录",
        component: () => import("@/views/sharedOffice/stationReservation/record"),
        meta: { title: "工位预约记录" },
      },
      {
        path: "receptionRoom/index",
        name: "洽谈室列表",
        component: () => import("@/views/sharedOffice/receptionRoom/index"),
        meta: { title: "洽谈室列表" },
      },
      {
        path: "receptionRoom/record",
        name: "洽谈室预约记录",
        component: () => import("@/views/sharedOffice/receptionRoom/record"),
        meta: { title: "洽谈室预约记录" },
      },
      {
        path: "policiesSupport",
        name: "政策扶持",
        redirect: '/sharedOffice/policiesSupport/index',
        component: () => import("@/views/sharedOffice/policiesSupport/home"),
        children: [
          {
            path: "index",
            name: "政策扶持列表",
            component: () => import("@/views/sharedOffice/policiesSupport/index"),
          },
          {
            path: "fundPolicyAllocation",
            name: "春风基金配置",
            component: () => import("@/views/sharedOffice/policiesSupport/fundPolicyAllocation"),
            meta: { title: "春风基金配置" },
          },
        ],
        meta: { title: "政策扶持列表" },
      },
      {
        path: "meetingRoomReservation/record",
        name: "会议室预约记录",
        component: () => import("@/views/sharedOffice/meetingRoomReservation/record"),
        meta: { title: "会议室预约记录" },
      },
      {
        path: "meetingRoomReservation/index",
        name: "会议室列表",
        component: () => import("@/views/sharedOffice/meetingRoomReservation/index"),
        meta: { title: "会议室列表" },
      },
      {
        path: "meetingRoomReservation/serviceList",
        name: "会议室服务列表",
        component: () => import("@/views/sharedOffice/meetingRoomReservation/serviceList"),
        meta: { title: "会议室服务列表" },
      },
    ],
  },
];

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  // { path: '/', redirect:'' },
  // { path: '/', redirect:'/party/buildingList' },
  // 404 page must be placed at the end !!!
  { path: "*", redirect: "/404", hidden: true },
];

// router.options.routes.unshift({ path: "/", redirect: '/party/buildingList' })
// asyncRoutes.forEach(item =>{
//   constantRoutes.push(item)
// })
const createRouter = () =>
  new Router({
    mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
